import React from 'react';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function CenterPanelCallerEntry(props) {
  return (
    <div className="ui form">
      {props.callerEntryPointForm.customUrl === null || props.callerEntryPointForm.customUrl === '' ? (
        ''
      ) : (
        <div>
          <div className="title-sms mrbs mrtm">
            {htmlToReactParser.parse(xss(APP.LANGUAGE.CallerEntryModal.YourWebsiteCaption1))}
          </div>
          <a target="caller_entry_point" href={props.callerEntryPointForm.customUrl}>
            {props.callerEntryPointForm.customUrl}
          </a>
          <div className="title-sms mrbm mrts">
            {htmlToReactParser.parse(xss(APP.LANGUAGE.CallerEntryModal.YourWebsiteCaption2))}
          </div>
          <hr style={{ border: '1px solid #e6e6e6' }} />
        </div>
      )}
      <div className="title-sms mrbs mrtm">
        <span>
          {htmlToReactParser.parse(
            xss(
              props.callerEntryPointForm.shortUrl === null || props.callerEntryPointForm.shortUrl === ''
                ? APP.LANGUAGE.CallerEntryModal.DefaultURLCaption0
                : `${APP.LANGUAGE.CallerEntryModal.DefaultURLCaption0} ${APP.LANGUAGE.CallerEntryModal.DefaultURLCaption1}`
            )
          )}
        </span>
      </div>

      <div className="center-flex display-flex one-line-input-field">
        {props.callerEntryPointForm.shortUrl === null || props.callerEntryPointForm.shortUrl === '' ? (
          <a target="caller_entry_point" href={props.callerEntryPointForm.longUrl}>
            {props.callerEntryPointForm.longUrl}
          </a>
        ) : (
          <a
            target="caller_entry_point"
            href={`${props.waitingArea.shortUrlDomain}${props.callerEntryPointForm.shortUrl}`}
          >
            {`${props.waitingArea.shortUrlDomain}${props.callerEntryPointForm.shortUrl}`}
          </a>
        )}
      </div>
      {props.waitingArea.isWaitingAreaPublic == true &&
      props.waitingArea.networkTypeId !== NetworkTypes.GroupConsultation ? (
        <div>
          <hr style={{ border: '1px solid #e6e6e6' }} className="mrtm" />
          <div className="center-flex display-flex center-flex mrtm mrbl">
            <div>{htmlToReactParser.parse(xss(APP.LANGUAGE.CallerEntryModal.ReadOnlyAllowAccessToWA))}</div>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
